import { memo } from 'react';
import Typography from '@mui/material/Typography';
import Checkbox from '@mui/material/Checkbox';
import Box from '@mui/material/Box';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import TableSortLabel from '@mui/material/TableSortLabel';
import visuallyHidden from '@mui/utils/visuallyHidden';

function DatatableHeader(props) {
    const { 
        rowCount, numSelected, order, orderBy, cellHeader, onRequestSort, onAllSelect, actions
    } = props;

    const createSortHandler = (property) => (e) => {
        onRequestSort(e, property);
    }
    return (
        <TableHead
            sx={{
                backgroundColor: 'rgba(0,0,0,0.02)',
                borderBottom: '2px solid rgba(0,0,0,0.1)',
            }}
        >
            <TableRow>
                <TableCell 
                    padding="checkbox"
                    sx={{
                        backgroundColor: 'transparent',
                        borderBottom: 'none',
                        padding: '12px 16px',
                    }}
                >
                    <Checkbox 
                        indeterminate={numSelected > 0 && numSelected < rowCount}
                        checked={rowCount > 0 && numSelected === rowCount}
                        onChange={onAllSelect}
                        sx={{
                            '&.Mui-checked': {
                                color: 'primary.main',
                            }
                        }}
                    />
                </TableCell>
                {cellHeader.map((cell) => (
                    <TableCell
                        key={cell.id}
                        align={cell.align}
                        sortDirection={orderBy === cell.id ? order : false}
                        sx={{
                            backgroundColor: 'transparent',
                            borderBottom: 'none',
                            padding: '12px 16px',
                            fontWeight: 600,
                            fontSize: '0.875rem',
                            color: 'rgba(0,0,0,0.8)',
                        }}
                    >
                        <TableSortLabel
                            hideSortIcon
                            active={orderBy === cell.id}
                            direction={orderBy === cell.id ? order : 'asc'}
                            onClick={createSortHandler(cell.id)}
                            sx={{
                                '&:hover': {
                                    backgroundColor: 'rgba(0,0,0,0.04)',
                                    borderRadius: 1,
                                },
                                '&.Mui-active': {
                                    color: 'primary.main',
                                }
                            }}
                        >
                            <Typography 
                                variant="subtitle2"
                                sx={{
                                    fontWeight: 600,
                                    fontSize: '0.875rem',
                                    color: 'inherit',
                                }}
                            >
                                {cell.label}
                            </Typography>
                            {orderBy === cell.id && (
                            <Box sx={{ ...visuallyHidden }}>
                                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                            </Box>
                            )}
                        </TableSortLabel>
                    </TableCell>
                ))}
                {actions && 
                <TableCell></TableCell>
                }
            </TableRow>
        </TableHead>
    )
}

DatatableHeader.defaultProps = {
    onAllSelect: () => {},
    onRequestSort: () => {},
    cellHeader: [],
    order: 'asc',
    numSelected: 0,
    orderBy: '',
    actions: false
}

export default memo(DatatableHeader);